module.exports = __webpack_public_path__ + "img/32 quien.a16e26f5.jpg";